import AddressGeocoder from './AddressGeocoder'
import { Chart, ChartMap, ChartMapDrilldown } from './Chart'
import CtrlEnterSubmit from './CtrlEnterSubmit'
import DatePicker from './DatePicker'
import DesignColor from './DesignColor'
import Dropdown from './Dropdown'
import EducationEmbedCountdown from './EducationEmbedCountdown'
import EducationVideoPlayer from './EducationVideoPlayer'
import EnterSubmit from './EnterSubmit'
import EventCarousel from './EventCarousel'
import ImageCropper from './ImageCropper'
import InviteCopy from './InviteCopy'
import Navigation from './Navigation'
import NavigationTopBar from './NavigationTopBar'
import LexicalEditor from './LexicalEditor'
import LiveStreamVideoPlayer from './LiveStreamVideoPlayer'
import OnboardingGeocoder from './OnboardingGeocoder'
import PhoneNumber from './PhoneNumber'
import PostV3 from './PostV3'
import PushEvent from './PushEvent'
import PushOnMount from './PushOnMount'
import RotateImages from './RotateImages'
import Scroll from './Scroll'
import SearchPageGeocoder from './SearchPageGeocoder'
import ShowMore from './ShowMore'
import Sortable from './Sortable'
import SortableInputsFor from './SortableInputsFor'
import StickyUpdate from './StickyUpdate'
import TimeFormat from './TimeFormat'
import Tooltip from './Tooltip'

/**
 * Adds hooks manually to elements that aren't powered by LiveView. This is to
 * allow for code-reuse.
 *
 * @returns {void}
 */
export function bind() {
  const hooks = {
    AddressGeocoder: AddressGeocoder.bind,
    PhoneNumber: PhoneNumber.bind,
    TimeFormat: TimeFormat.bind,
  }

  const elements = document.querySelectorAll('[data-hook]')

  for (let i = 0; i < elements.length; i++) {
    const element = elements[i]
    const name = element.getAttribute('data-hook')

    hooks[name](element)
  }
}

export default {
  AddressGeocoder: AddressGeocoder.hook,
  Chart,
  ChartMap,
  ChartMapDrilldown,
  CtrlEnterSubmit,
  DesignColor,
  Dropdown,
  EducationEmbedCountdown,
  EducationVideoPlayer,
  EnterSubmit,
  EventCarousel,
  ImageCropper,
  InviteCopy,
  LiveStreamVideoPlayer,
  LexicalEditor,
  Navigation,
  NavigationTopBar,
  OnboardingGeocoder,
  PhoneNumber: PhoneNumber.hook,
  PostV3,
  PushEvent,
  PushOnMount,
  RotateImages,
  Scroll,
  SearchPageGeocoder,
  ShowMore,
  Sortable,
  SortableInputsFor,
  StickyUpdate,
  DatePicker,
  TimeFormat: TimeFormat.hook,
  Tooltip,
}
